import React, { useState } from "react";
import _ from "lodash";
import moment from "moment";
import "moment-timezone";
import BootstrapTable from "react-bootstrap-table-next";
import "react-bootstrap-table/css/react-bootstrap-table.css";
import DatePicker from "react-datepicker";
import { Modal, Button } from "react-bootstrap";
import { CheckOut } from "../../partial/newCheckOut";
import { AddPO } from "../../partial/addPO";
import DepositModal from "../../partial/DepositModal";
import CompletionPhotosModal from "../../partial/CompletionPhotosModal";
import Select from "../../common/select";
import "react-datepicker/dist/react-datepicker.css";
import StarRatingComponent from "react-star-rating-component";
import { convertToUTC, convertFromUTC } from "../../../util/convert_timezone";
import PaymentProgressModal from "../../partial/PaymentProgressModal";
import { HTTPService } from "./../../../services/httpService";
import { canTransferJob } from "../../../util/jobUtils";
import { getScheduleNotification, formatDisplayDate} from "../../../util/dateDisplayUtils";
import TransferInterface from "../../../components/TransferInterface";

const API = new HTTPService();

// Constants
const USER_ACCESS_ASSIST = "ASSIST";
const USER_ACCESS_ADMIN = "ADMIN";
const REQUEST_STATES = {
  NEW: "new",
  ANSWERED: "answered",
  SCHEDULED: "scheduled",
  STARTED: "started",
  RECEIVED: "received",
  FINISHED: "finished",
  COLLECTED: "collected"
};

const USER_TYPES = {
  DEALER: "dealer",
  INSTALLER: "installer"
};

const REQUEST_TYPES = {
  DEALER: "dealer",
  INSTALLER: "installer"
};

const SERVICE_STATES = {
  NEW: "new",
  STARTED: "started"
};

const WORK_STATUSES = ['booked', 'pending', 'started'];

// Utility Functions
const formatCurrency = (amount) => {
  return isNaN(amount) ? "$0.00" : "$" + amount.toFixed(2);
};

const ScheduleNotification = ({ request, calendarDays }) => {
//console.log("ScheduleNotification called with request:", request, calendarDays);
  const notification = getScheduleNotification(request, calendarDays);
//console.log("ScheduleNotification returns:", notification);
  
  if (!notification) return null;
  
  const alertClass = notification.type === 'warning' ? 'alert-warning' : 'alert-info';
  
  return (
    <div className={`alert ${alertClass} mx-3 mb-3`} style={{ fontSize: '14px' }}>
      {notification.icon} {notification.message}
    </div>
  );
};

// Helper function to fetch signed URL for contract viewing
const fetchSignedUrl = async (requestId) => {
  const newTab = window.open("", "_blank");
  try {
    const response = await API.get(`signedURL/?requestId=${requestId}`);
    if (response.data.signedUrl) {
      newTab.location.href = response.data.signedUrl;
    } else {
      console.error("No signed URL found.");
      alert("Error accessing contract.");
    }
  } catch (error) {
    console.error("Error fetching signed URL:", error);
    alert("Error accessing contract.");
  }
};

const formatServiceAmount = (service, discount = 0) => {
  // If service_discount is already stored separately, use it
  const serviceDiscount = service.service_discount || discount || 0;
  const amount = parseFloat(service.service_amount) - parseFloat(serviceDiscount);
  return formatCurrency(amount);
};

const formatDateString = (date) => {
  return convertToUTC(date).format("ddd, MMM Do, YYYY");
};

// Currency formatter for table columns
const currencyFormatter = (cell, row) => {
  if (typeof cell === 'string' && cell.startsWith('$')) {
    return cell; // Already formatted
  }
  const amount = parseFloat(cell) || 0;
  return formatCurrency(amount);
};

const prepareServiceData = (services) => {
  return services.map(service => {
    // Don't modify service_amount - let the formatter handle discount display
    return {
      ...service,
      service_amount: parseFloat(service.service_amount), // Keep original amount
      service_discount: parseFloat(service.service_discount || 0)
    };
  });
};
const prepareOffersData = (offers) => {
  return offers.map(offer => ({
    ...offer,
    startDateString: formatDateString(offer.startDate),
    installerName: offer.installerName
  }));
};

const handleCheckIn = async (request, routerHistory) => {

  console.log ("here's the requst for checkin", request)
  try {

      routerHistory.push(`/requests/${request.requestId}/checkin`);
/*
    // Check if check-in wizard is enabled for this installer
    const installer = this.state.installer || this.props.installer;

    if (installer && installer.checkin_wizard_enabled) {
      // Use new check-in wizard
      this.props.history.push(`/requests/${requestId}/checkin`);
    } else {
      // Fallback to existing simple flow (if you have one)
      alert('Check-in wizard not enabled for this account');
    }
      */
  } catch (error) {
    console.error('Error starting check-in:', error);
    alert('Error starting check-in. Please try again.');
  }
};

const getServiceColumns = () => [
  { dataField: "service_category", text: "Category" },
  { dataField: "description", text: "Service" },
  { 
    dataField: "service_amount", 
    text: "Amount", 
    formatter: (cell, row) => formatServiceAmount(row)
  },
  { dataField: "service_duration", text: "Duration" }
];
// Add this enhanced column definition for dealers near the existing getServiceColumns function
const getDealerServiceColumns = () => [
  { dataField: "service_category", text: "Category" },
  { dataField: "description", text: "Service" },
{ 
  dataField: "service_amount", 
  text: "Specialist Cost", 
  formatter: (cell, row) => formatServiceAmount(row)
},  { 
    dataField: "retail_price", 
    text: "Customer Price", 
    formatter: (cell, row) => {
      // Use retail_price if available, otherwise fall back to service_amount
      const retailPrice = cell || row.service_amount || 0;
      return formatCurrency(parseFloat(retailPrice));
    }
  },
{
  dataField: "margin",
  text: "Margin",
  formatter: (cell, row) => {
    const retailPrice = parseFloat(row.retail_price || row.service_amount || 0);
    const serviceDiscount = parseFloat(row.service_discount || 0);
    const specialistCost = parseFloat(row.service_amount || 0) - serviceDiscount; // ✅ Discounted
    const margin = retailPrice - specialistCost;
    return (
      <span className={margin >= 0 ? "text-success" : "text-danger"}>
        {formatCurrency(margin)}
      </span>
    );
  }
},
  { dataField: "service_duration", text: "Duration" }
];

const getCustomServiceColumns = () => [
  { dataField: "service_category", text: "Category" },
  { dataField: "custom_description", text: "Service" },
  { 
    dataField: "service_amount", 
    text: "Amount", 
    formatter: (cell, row) => formatServiceAmount(row)
  },
  { dataField: "service_duration", text: "Duration" }
];

const getServiceStatusColumns = () => [
  { dataField: "service_category", text: "Category" },
  { dataField: "description", text: "Service" },
  { dataField: "Status", text: "Status" }
];

const getOfferColumns = () => [
  { dataField: "installerName", text: "Installer" },
  { dataField: "startDateString", text: "Date to Start" }
];

const getWorkServiceColumns = () => [
  { dataField: "service_category", text: "Category" },
  { dataField: "custom_description", text: "Service" },
  { 
    dataField: "service_amount", 
    text: "Amount", 
    formatter: (cell, row) => formatServiceAmount(row)
  },
  { dataField: "service_duration", text: "Duration" },
  { dataField: "service_state", text: "State" }
];
// Helper Functions
const isEmpty = (obj) => {
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) return false;
  }
  return true;
};

const calculateExcludeDates = (excludeDays, installer, thisJob) => {
  let exclude = [];
  if (thisJob.length > 0) {
    for (let b = 0; b < excludeDays.length; b++) {
      if (excludeDays[b].y > installer.capacity - thisJob[0].duration) {
        exclude.push(
          new Date(moment(excludeDays[b].exDate).format("MMMM D, YYYY"))
        );
      }
    }
  }
  return exclude;
};

const calculateExistingCommitments = (calendarDays, currentRequestId = null) => {
  let existingCommitmentDates = [];
  const today = moment().startOf('day');
  
  for (let c = 0; c < calendarDays.length; c++) {
    const workDate = moment(calendarDays[c].workDate).startOf('day');
    const isCurrentJob = currentRequestId && calendarDays[c].requestId === currentRequestId;
    
    // Only include commitments from today forward, with active status, excluding current job
    if (WORK_STATUSES.includes(calendarDays[c].workStatus) && 
        workDate.isSameOrAfter(today) &&
        !isCurrentJob) {
      existingCommitmentDates.push(
        new Date(workDate.format("MMMM D, YYYY"))
      );
    }
  }
  
  return existingCommitmentDates;
};

const getPaymentList = (installer, canUseSplitPayment, userAccess, requestType) => {
  let basePayList = ["Check", "Cash", "Pay Online", "Swipe Card"];

  // Add Split Payment option if eligible AND not a dealer job
  if (canUseSplitPayment && requestType !== REQUEST_TYPES.DEALER) {
    basePayList = ["Split Payment", ...basePayList];
  }

  return installer.stripe_location === ""
    ? (canUseSplitPayment && requestType !== REQUEST_TYPES.DEALER ? ["Split Payment", "Check", "Cash", "Pay Online", "Settle"] : ["Check", "Cash", "Pay Online", "Settle"])
    : basePayList;
};

const prepareServiceStatusData = (services) => {
  return services.map(service => ({
    service_id: service.service_id,
    service_category: service.service_category,
    description: service.description,
    Status: _.capitalize(service.service_state)
  }));
};

// Reusable Components
const ServiceTable = ({ data, columns, keyField = "service_id", selectRow, rowEvents }) => {
  const tableProps = {
    keyField,
    data,
    columns
  };
  
  // Only add selectRow if it's provided and not null
  if (selectRow) {
    tableProps.selectRow = selectRow;
  }
  
  // Only add rowEvents if it's provided and not null
  if (rowEvents) {
    tableProps.rowEvents = rowEvents;
  }
  
  return (
    <div className="table-responsive">
      <BootstrapTable {...tableProps} />
    </div>
  );
};

// REPLACE the existing AvailabilityAlert component in requestimateState.jsx

const AvailabilityAlert = ({ availability, calendarDays, requestId, selectedDate }) => {
  if (!availability) return null;
  
  const selectedDateStr = moment(selectedDate).format("YYYY-MM-DD");
  const suggestedDateStr = moment(availability.nextStart).format("YYYY-MM-DD");
  const isUserOverride = selectedDateStr !== suggestedDateStr;
  
  // Check for conflicts on selected date
  const conflictsOnSelectedDate = calendarDays?.filter(entry => 
    moment(entry.workDate).format("YYYY-MM-DD") === selectedDateStr && 
    ['booked', 'started'].includes(entry.workStatus) &&
    entry.requestId !== requestId
  ).length || 0;
  
  const getAlertType = () => {
    if (conflictsOnSelectedDate > 0) return 'warning';
    if (availability.canFit !== false) return 'success';
    return 'info';
  };
  
  const getCapacityMessage = () => {
    if (conflictsOnSelectedDate > 0) {
      return `⚠️ ${conflictsOnSelectedDate} confirmed job(s) on this date - schedule adjustment may be needed`;
    }
    
    if (availability.canFit !== false) {
      return "✅ Fits within normal capacity";
    }
    
    return "ℹ️ May require working over normal capacity";
  };
  
  return (
    <div className="form-row justify-content-md-center mb-3">
      <div className="col-md-8">
        <div className={`alert alert-${getAlertType()}`}>
          <strong>📅 Selected Date:</strong> {moment(selectedDate).format("MMM DD, YYYY")}
          {availability.totalJobDays && availability.totalJobDays > 1 && (
            <span> ({availability.totalJobDays}-day job)</span>
          )}
          
          <div style={{ margin: "8px 0" }}>
            {getCapacityMessage()}
          </div>
          
          {/* Show suggestion if different from selection */}
          {isUserOverride && (
            <div style={{ color: "#6c757d", fontSize: "14px" }}>
              💡 Suggested date: {moment(availability.nextStart).format("MMM DD, YYYY")} 
              (optimal fit)
            </div>
          )}
                    
          {/* Capacity details if available */}
          {availability.availableSlots !== undefined && (
            <div style={{ fontSize: "12px", color: "#6c757d", marginTop: "5px" }}>
              Capacity: {availability.availableSlots} of {availability.availableSlots + (availability.existingJobs || 0)} slots available
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

// REPLACE the DatePickerSection component in requestimateState.jsx with this:

const DatePickerSection = ({ 
  sDate, 
  minDate, 
  maxDate, 
  exclude, 
  existingCommitmentDates, 
  onStartDateChange, 
  label = "Pick Start Date" 
}) => {
  // Memoize the date picker to prevent unnecessary re-renders
  const memoizedDatePicker = React.useMemo(() => (
    <DatePicker
      selected={sDate}
      onChange={onStartDateChange}
      minDate={minDate}
      maxDate={maxDate}
      excludeDates={exclude}
      highlightDates={existingCommitmentDates}
      dateFormat="MMMM d, yyyy"
      className="form-control"
      placeholderText="Click to select date"
      showPopperArrow={false}
      popperClassName="date-picker-popper"
      calendarClassName="date-picker-calendar"
    />
  ), [
    moment(sDate).format("YYYY-MM-DD"), // Use string comparison for dates
    moment(minDate).format("YYYY-MM-DD"),
    maxDate ? moment(maxDate).format("YYYY-MM-DD") : null,
    exclude.length, // Just track array length
    existingCommitmentDates.length, // Just track array length
    onStartDateChange
  ]);

  return (
    <div className="mt-4 mb-4">
      <div className="row">
        <div className="col">
          <form className="form-row justify-content-md-center">
            <div className="form-group col-lg-2 text-center">
              <label className="bold">{label}</label>
            </div>
            <div className="form-group col-lg-4">
              <div className="input-group">
                {memoizedDatePicker}
                <div className="input-group-append">
                  <span className="input-group-text">
                    <i className="fa fa-calendar" aria-hidden="true"></i>
                  </span>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

const ActionButton = ({ onClick, className, disabled = false, children, userAccess }) => {
  if (userAccess === USER_ACCESS_ASSIST) return null;
  
  return (
    <button
      type="button"
      onClick={onClick}
      className={className}
      disabled={disabled}
    >
      {children}
    </button>
  );
};

const VehicleInfo = ({ request, vin, vinGood, vehicleEntered, onVINChange }) => (
  <div className="mt-4 mb-4">
    <h6>
      Scheduled drop off date: {moment(request.availableDate).format("MM/DD/YYYY")}
    </h6>
    {request.vin.substring(0, 2) !== "NV" ? (
      <div>
        <h6>VIN: {request.vin}</h6>
      </div>
    ) : (
      <div>
        <form>
          <div className="form-row justify-content-md-center">
            <div className="form-group col-lg-2 text-center">
              <label className="bold">Enter VIN #</label>
            </div>
            <div className="form-group col-lg-4">
              <input
                name="vin"
                id={vin}
                value={vin}
                onChange={onVINChange}
              />
            </div>
          </div>
        </form>
      </div>
    )}
    {vinGood && request.vin.substring(0, 2) === "NV" && (
      <div>
        <p>
          {vehicleEntered.ModelYear} {vehicleEntered.Make} {vehicleEntered.Model}
        </p>
      </div>
    )}
  </div>
);

const SplitPaymentModal = ({
  show,
  onHide,
  request,
  invoice,
  collectedPayments,
  remainingBalance,
  splitPaymentAmount,
  selectedSplitMethod,
  splitCheckNumber,
  isProcessingSplitPayment,
  splitPaymentError,
  onSplitMethodChange,
  onSplitAmountChange,
  onSplitCheckNumberChange,
  onCollectSplitPayment,
  userAccess
}) => {
  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Split Payment</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="split-payment-container">
          {/* Deposit Credit Display */}
          {request.depositAmount > 0 && (
            <div className="row mb-3">
              <div className="col-12">
                <div className="alert alert-info text-center">
                  <strong>Deposit Credit Applied: ${request.depositAmount.toFixed(2)}</strong>
                </div>
              </div>
            </div>
          )}

          {/* Invoice Totals */}
          <div className="row mb-3">
            <div className="col-12">
              <div className="split-payment-totals p-3 bg-light rounded">
                <div className="d-flex justify-content-between mb-2">
                  <span>Subtotal:</span>
                  <span>${request.requestTotal?.toFixed(2)}</span>
                </div>
                {request.requestDiscount > 0 && (
                  <div className="d-flex justify-content-between mb-2">
                    <span>Discount:</span>
                    <span className="text-success">-${request.requestDiscount.toFixed(2)}</span>
                  </div>
                )}
                {request.requestTaxes > 0 && (
                  <div className="d-flex justify-content-between mb-2">
                    <span>Sales Tax:</span>
                    <span>${request.requestTaxes.toFixed(2)}</span>
                  </div>
                )}
                <hr />
                <div className="d-flex justify-content-between mb-2">
                  <span className="font-weight-bold">Total Amount Due:</span>
                  <span className="font-weight-bold">
                    ${((request.requestTotal - (request.requestDiscount || 0)) + (request.requestTaxes || 0)).toFixed(2)}
                  </span>
                </div>
                {request.depositAmount > 0 && (
                  <div className="d-flex justify-content-between mb-2">
                    <span>Deposit Credit:</span>
                    <span className="text-success">-${request.depositAmount.toFixed(2)}</span>
                  </div>
                )}
                {collectedPayments.length > 0 && (
                  <div className="d-flex justify-content-between mb-2">
                    <span>Payments Collected:</span>
                    <span className="text-success">
                      -${collectedPayments.reduce((sum, p) => sum + p.payment_amount, 0).toFixed(2)}
                    </span>
                  </div>
                )}
                <hr />
                <div className="d-flex justify-content-between">
                  <span className="font-weight-bold">Remaining Balance:</span>
                  <span className="font-weight-bold text-primary">
                    ${remainingBalance?.toFixed(2)}
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* Collected Payments List */}
          {collectedPayments.length > 0 && (
            <div className="row mb-3">
              <div className="col-12">
                <h6 className="font-weight-bold">Collected Payments:</h6>
                <div className="list-group">
                  {collectedPayments.map((payment, index) => (
                    <div key={payment.payment_id || index} className="list-group-item">
                      <div className="d-flex justify-content-between align-items-center">
                        <div>
                          <strong>Payment {index + 1}</strong>
                          <br />
                          <small className="text-muted">
                            Method: {payment.payment_method}
                            {payment.check_number && ` | Check #${payment.check_number}`}
                            {payment.payment_state && ` | Status: ${payment.payment_state}`}
                          </small>
                        </div>
                        <span className="badge badge-success badge-lg">
                          ${payment.payment_amount.toFixed(2)}
                        </span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}

          {/* Next Payment Form */}
          {remainingBalance > 0 && (
            <div className="row">
              <div className="col-12">
                <div className="split-payment-form p-3 border rounded">
                  <h6 className="font-weight-bold mb-3">Collect Next Payment</h6>

                  {/* Error Display */}
                  {splitPaymentError && (
                    <div className="alert alert-danger">
                      {splitPaymentError}
                    </div>
                  )}

                  {/* Payment Method Selection */}
                  <div className="form-group">
                    <label className="font-weight-bold">
                      Payment Method <span className="text-danger">*</span>
                    </label>
                    <div className="btn-group d-flex" role="group">
                      <button
                        type="button"
                        className={`btn ${selectedSplitMethod === 'Terminal' ? 'btn-primary' : 'btn-outline-primary'}`}
                        onClick={() => onSplitMethodChange('Terminal')}
                      >
                        Terminal
                      </button>
                      <button
                        type="button"
                        className={`btn ${selectedSplitMethod === 'Online' ? 'btn-primary' : 'btn-outline-primary'}`}
                        onClick={() => onSplitMethodChange('Online')}
                      >
                        Online Card
                      </button>
                      <button
                        type="button"
                        className={`btn ${selectedSplitMethod === 'Cash' ? 'btn-primary' : 'btn-outline-primary'}`}
                        onClick={() => onSplitMethodChange('Cash')}
                      >
                        Cash
                      </button>
                      <button
                        type="button"
                        className={`btn ${selectedSplitMethod === 'Check' ? 'btn-primary' : 'btn-outline-primary'}`}
                        onClick={() => onSplitMethodChange('Check')}
                      >
                        Check
                      </button>
                    </div>
                  </div>

                  {/* Payment Amount Input */}
                  <div className="form-group">
                    <label className="font-weight-bold">
                      Payment Amount <span className="text-danger">*</span>
                    </label>
                    <div className="input-group">
                      <div className="input-group-prepend">
                        <span className="input-group-text">$</span>
                      </div>
                      <input
                        type="number"
                        className="form-control"
                        value={splitPaymentAmount}
                        onChange={(e) => onSplitAmountChange(e.target.value)}
                        placeholder="0.00"
                        min="0"
                        max={remainingBalance}
                        step="0.01"
                      />
                    </div>
                    <small className="form-text text-muted">
                      Maximum: ${remainingBalance?.toFixed(2)}
                    </small>
                  </div>

                  {/* Check Number Input - Only for Check payments */}
                  {selectedSplitMethod === 'Check' && (
                    <div className="form-group">
                      <label className="font-weight-bold">
                        Check Number <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        value={splitCheckNumber}
                        onChange={(e) => onSplitCheckNumberChange(e.target.value)}
                        placeholder="Enter check number"
                      />
                    </div>
                  )}

                  {/* Collect Payment Button */}
                  <div className="text-center mt-3">
                    <button
                      className="btn btn-success btn-lg"
                      onClick={onCollectSplitPayment}
                      disabled={isProcessingSplitPayment || !selectedSplitMethod || !splitPaymentAmount}
                    >
                      {isProcessingSplitPayment ? (
                        <>
                          <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                          Processing...
                        </>
                      ) : (
                        `Collect Payment - $${splitPaymentAmount || '0.00'}`
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Complete Button - Show when balance is $0 */}
          {remainingBalance === 0 && (
            <div className="row mt-3">
              <div className="col text-center">
                <div className="alert alert-success">
                  <strong>All payments collected! Invoice is fully paid.</strong>
                </div>
              </div>
            </div>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

// Dealer Reschedule Modal Component
const DealerRescheduleModal = ({
  show,
  onHide,
  request,
  onConfirm,
  availableDate,
  dueDate,
  onAvailableDateChange,
  onDueDateChange
}) => {
  // Handle available date change with smart due date adjustment
  const handleAvailableDateChange = (date) => {
    onAvailableDateChange(date);

    // If the new available date is after the current due date,
    // automatically update due date to match available date
    if (dueDate && moment(date).isAfter(moment(dueDate))) {
      onDueDateChange(date);
    }
  };

  const today = moment().startOf('day').toDate();

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Reschedule Job</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="reschedule-modal-container">
          <div className="alert alert-info">
            <strong>Current Schedule:</strong>
            <br />
            Available Date: {moment(request.availableDate).format("MM/DD/YYYY")}
            <br />
            Due Date: {moment(request.dueDate).format("MM/DD/YYYY")}
          </div>

          <div className="form-group">
            <label htmlFor="availableDate" className="font-weight-bold">
              Available Date <span className="text-danger">*</span>
            </label>
            <DatePicker
              id="availableDate"
              selected={availableDate}
              onChange={handleAvailableDateChange}
              minDate={today}
              dateFormat="MM/dd/yyyy"
              className="form-control"
              placeholderText="Select available date"
            />
            <small className="form-text text-muted">
              When the vehicle will be available for the specialist to start work
            </small>
          </div>

          <div className="form-group mt-3">
            <label htmlFor="dueDate" className="font-weight-bold">
              Due Date <span className="text-danger">*</span>
            </label>
            <DatePicker
              id="dueDate"
              selected={dueDate}
              onChange={onDueDateChange}
              minDate={availableDate || today}
              dateFormat="MM/dd/yyyy"
              className="form-control"
              placeholderText="Select due date"
            />
            <small className="form-text text-muted">
              Deadline for completing the work
            </small>
          </div>

          {availableDate && dueDate && moment(dueDate).isBefore(availableDate) && (
            <div className="alert alert-danger mt-3">
              Due date cannot be before available date
            </div>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>
        <Button
          variant="warning"
          onClick={onConfirm}
          disabled={!availableDate || !dueDate || moment(dueDate).isBefore(availableDate)}
        >
          Update Schedule
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

const RequestimateState = (props) => {
  // Detect if mobile device
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  const {
    userType,
    typeId,
    userAccess,
    installer,
    request,
    services,
    notes,
    displayedList,
    offers,
    history,
    routerHistory,
    invoice,
    calendarDays,
    excludeDays,
    startDate,
    paymentIntentId,
    onStartDateChange,
    template,
    onTemplateChange,
    materials,
    onMaterialsChange,
    vin,
    vehicleEntered,
    vinGood,
    onVINChange,
    rowSelected,
    onDelete,
    onSelectOffer,
    selectedInstaller,
    selectedService,
    onAccept,
    onAcceptEstimate,
    onCompleteEstimate,
    onReject,
    onAssign,
    onReceive,
    onReschedule,
    onDealerReschedule,
    canDealerReschedule,
    onStart,
    onFinish,
    onComplete,
    onSelectService,
    onSelectInstaller,
    showDepositModal,
    onShowDepositModal,
    onHideDepositModal,
    onSaveDeposit,
    onCreateDepositInvoice,
    onEdit,
    reviewScore,
    onReviewScoreChange,
    onSettle,
    onResend,
    onFinalize,
    onReview,
    selectedPay,
    checkNumber,
    onPaymentChange,
    onCheckNumberChange,
    onPayment,
    onDeliver,
    onPageChange,
    activePage,
    showSwipe,
    closeSwipe,
    showPO,
    closePO,
    onAddPO,
    onPO,
    loading,
    availability,
    // NEW PROPS for progress modal:
    paymentState,
    paymentError,
    onRetryPayment,
    showTransferModal,
    onShowTransferModal,
    onHideTransferModal,
    company,
    onJobTransfer,

    // Split Payment Props
    isSplitPayment,
    collectedPayments,
    splitPaymentAmount,
    selectedSplitMethod,
    splitCheckNumber,
    finalInvoiceId,
    isProcessingSplitPayment,
    splitPaymentError,
    remainingBalance,
    canUseSplitPayment,
    onToggleSplitPayment,
    onCollectSplitPayment,
    onSplitMethodChange,
    onSplitAmountChange,
    onSplitCheckNumberChange,
    showInvoiceLinkModal,
    currentInvoiceLink,
    onCloseInvoiceLinkModal
  } = props;

  // Local state for completion photos modal
  const [showCompletionPhotos, setShowCompletionPhotos] = useState(false);
  const [showSplitPaymentModal, setShowSplitPaymentModal] = useState(false);

  // Local state for dealer reschedule modal
  const [showDealerRescheduleModal, setShowDealerRescheduleModal] = useState(false);
  const [rescheduleAvailableDate, setRescheduleAvailableDate] = useState(null);
  const [rescheduleDueDate, setRescheduleDueDate] = useState(null);

  const payList = getPaymentList(installer, canUseSplitPayment, userAccess, request.requestType);

  function stripeOutside(url) {
    //console.log(invoice);
    window.open(url);
  }

  const handleCompletionPhotosSuccess = () => {
    // Refresh the page or reload request data after successful upload
    window.location.reload();
  };

  // Early returns for empty state
  if (isEmpty(request)) {
    return null;
  }

  const check = displayedList.filter(
    (item) => item.requestId === request.requestId
  );

  if (check.length === 0) {
    return null;
  }

  // Prepare data
  const displayOffers = prepareOffersData(offers);
  let selectedOffer = [];

  //console.log("Handle Deliver : State : request : ", request);
  //console.log("Handle Deliver : State : company : ", installer);

  const noteText = notes.length > 0 && notes[0].note_text.length > 1 
    ? notes[0].note_text 
    : "None";

  // Filter offers based on user type
  if (userType === USER_TYPES.INSTALLER) {
    const matchingOffers = offers.filter(
      (offer) => offer.installerId === parseInt(typeId)
    );
    selectedOffer = matchingOffers.length > 0 ? matchingOffers[0] : {};
  }
  
  if (userType === USER_TYPES.DEALER) {
    const filteredOffers = offers.filter(
      (offer) => offer.currentStatus === "accepted"
    );
    displayOffers.splice(0, displayOffers.length, ...prepareOffersData(filteredOffers));
  }

// REPLACE the date calculation section in requestimateState.jsx (around lines 570-610)

// Date calculations - MEMOIZED to prevent infinite recalculation
const thisService = activePage - 1;
let dueDate = new Date(request.dueDate);

if (userType === USER_TYPES.INSTALLER && request.requestType === REQUEST_TYPES.INSTALLER) {
  let calcDate = new moment(request.dueDate).add(30, "days");
  dueDate = new Date(calcDate);
}

// FIXED: Use useMemo equivalent with React.useMemo or move to useEffect
// For now, let's use a more stable approach with string comparisons

// SIMPLIFIED: Always respect specialist's choice but stabilize date objects
const startDateStr = moment(startDate).format("YYYY-MM-DD");
const todayStr = moment().format("YYYY-MM-DD");
const dueDateStr = moment(dueDate).format("YYYY-MM-DD");

// Universal minimum date (can't book in the past) - use string comparison first
let sDate;
if (startDateStr < todayStr) {
//console.log("🎯 Selected date too early, using today");
  sDate = moment().startOf('day').toDate();
} else {
  sDate = moment(startDate).toDate();
}

// DEALER JOBS: Respect due date constraint - use string comparison
let maxDate = null;
if (request.requestType === REQUEST_TYPES.DEALER) {
  const jobDuration = parseInt(request.requestDuration) || 1;
  const latestStartDateStr = moment(request.dueDate).subtract(jobDuration - 1, "days").format("YYYY-MM-DD");
  
  if (startDateStr > latestStartDateStr) {
    //console.log("🎯 Selected date too late for dealer due date, adjusting");
    sDate = moment(latestStartDateStr).toDate();
  }
  
  maxDate = moment(latestStartDateStr).toDate();
  //console.log("🎯 DEALER JOB: Due date constraint applied, must start by:", maxDate);
}

// Use consistent date objects to prevent re-renders
const minDate = moment().startOf('day').toDate();

// Remove the excessive logging that was causing console spam
/* console.log("🎯 Final date calculation:", {
  userSelected: startDateStr,
  finalDate: moment(sDate).format("YYYY-MM-DD"),
  jobType: request.requestType
});*/

  //console.log("User Type : ", userType);
  //console.log("Request Type : ", request.requestType);
  //console.log("Current State : ", request.currentState);
  //console.log("Assigned To : ", request.assignedTo);

  // Job services setup
  const thisJobServices = Array.from(
    calendarDays.filter((day) => day.requestId === request.requestId)
  );
  const thisJob = _.orderBy(thisJobServices, "serviceId", "asc");
  const serviceCount = thisJob.length;

  // Calculate exclude dates and commitments
//  const exclude = calculateExcludeDates(excludeDays, installer, thisJob);
const exclude = [];
const existingCommitmentDates = calculateExistingCommitments(calendarDays);

  // Invoice processing
  const workingInvoice = JSON.parse(JSON.stringify(invoice));
  const findMeta = Object.entries(workingInvoice);
  const findValue = findMeta[48];

  //console.log("RequestimateState : Working Invoice ", workingInvoice);

  //************************************************************************
  //***************************  Dealer Pages ******************************
  //************************************************************************

if (request.currentState === REQUEST_STATES.NEW && userType === USER_TYPES.DEALER) {
  const services_ = Array.from(services);
  // Check if this dealer is configured to require contracts
  const dealerRequiresContracts = props.company?.customer_contract === 'Y';

  // Check if dealer can reschedule
  const rescheduleCheck = canDealerReschedule ? canDealerReschedule(request) : { canReschedule: false };

  const handleRescheduleClick = () => {
    // Initialize modal with current dates
    setRescheduleAvailableDate(moment(request.availableDate).toDate());
    setRescheduleDueDate(moment(request.dueDate).toDate());
    setShowDealerRescheduleModal(true);
  };

  const handleRescheduleConfirm = () => {
    onDealerReschedule(request, rescheduleAvailableDate, rescheduleDueDate);
    setShowDealerRescheduleModal(false);
  };

  return (
    <React.Fragment>
      <div className="card text-center">
        <div className="card-body">
          {/* Enhanced service table showing both specialist cost and customer retail price */}
          <ServiceTable
            data={services_}
            columns={getDealerServiceColumns()}
          />

          {/* Action Buttons - including contract button inline */}
          <div className="text-center">
            {/* Contract Button - Only if dealer requires contracts */}
            {dealerRequiresContracts && (
              request.contract_url ? (
                <ActionButton
                  onClick={() => fetchSignedUrl(request.requestId)}
                  className="btn btn-info m-2 buttons"
                  userAccess={userAccess}
                >
                  VIEW CONTRACT
                </ActionButton>
              ) : (
                <ActionButton
                  onClick={() => window.location.href = `/contract/${request.requestId}`}
                  className="btn btn-primary m-2 buttons"
                  userAccess={userAccess}
                >
                  CREATE CONTRACT
                </ActionButton>
              )
            )}

            {/* Reschedule Button */}
            {rescheduleCheck.canReschedule && (
              <ActionButton
                onClick={handleRescheduleClick}
                className="btn btn-warning m-2 buttons"
                userAccess={userAccess}
              >
                RESCHEDULE
              </ActionButton>
            )}

            <ActionButton
              onClick={() => onDelete(request)}
              className="button btn-danger m-2 buttons"
              userAccess={userAccess}
            >
              DELETE
            </ActionButton>
          </div>
        </div>
      </div>

      {/* Dealer Reschedule Modal */}
      <DealerRescheduleModal
        show={showDealerRescheduleModal}
        onHide={() => setShowDealerRescheduleModal(false)}
        request={request}
        onConfirm={handleRescheduleConfirm}
        availableDate={rescheduleAvailableDate}
        dueDate={rescheduleDueDate}
        onAvailableDateChange={setRescheduleAvailableDate}
        onDueDateChange={setRescheduleDueDate}
      />
    </React.Fragment>
  );
}

// Answered request for Dealer - WITH CONTRACT OPTION
if (request.currentState === REQUEST_STATES.ANSWERED && userType === USER_TYPES.DEALER) {
  const selectRow = {
    mode: "radio",
    clickToSelect: true,
    bgColor: "grey",
    onClick: (e, row, rowIndex) => {
      onSelectInstaller(row);
    },
  };

  const rowEvents = {
    onClick: (e, row, rowIndex) => {
      onSelectInstaller(row);
    },
  };

  // Check if this dealer is configured to require contracts
  const dealerRequiresContracts = props.company?.customer_contract === 'Y';

  return (
    <React.Fragment>
      <div className="card text-center">
        <div className="card-body">
          <h5 className="card-title">
            Approve the work for the specialist to start
          </h5>
          <ServiceTable 
            data={displayOffers} 
            columns={getOfferColumns()}
            keyField="installerId"
            selectRow={selectRow}
            rowEvents={rowEvents}
          />
          
          {/* Action Buttons - including contract button inline */}
          <div className="text-center">
            {/* Contract Button - Only if dealer requires contracts */}
            {dealerRequiresContracts && (
              request.contract_url ? (
                <ActionButton
                  onClick={() => fetchSignedUrl(request.requestId)}
                  className="btn btn-info m-2 buttons"
                  userAccess={userAccess}
                >
                  VIEW CONTRACT
                </ActionButton>
              ) : (
                <ActionButton
                  onClick={() => window.location.href = `/contract/${request.requestId}`}
                  className="btn btn-primary m-2 buttons"
                  userAccess={userAccess}
                >
                  CREATE CONTRACT
                </ActionButton>
              )
            )}
            
            <ActionButton
              onClick={() => onAssign(request, selectedInstaller)}
              className="btn btn-success m-2 buttons"
              disabled={!selectedInstaller}
              userAccess={userAccess}
            >
              ASSIGN
            </ActionButton>
            <ActionButton
              onClick={() => onDelete(request)}
              className="button btn-danger m-2 buttons"
              userAccess={userAccess}
            >
              DELETE
            </ActionButton>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

// RECEIVED state for Dealer - with reschedule option
  if (request.currentState === REQUEST_STATES.RECEIVED && userType === USER_TYPES.DEALER) {
    const services_ = prepareServiceStatusData(services);

    // Check if dealer can reschedule
    const rescheduleCheck = canDealerReschedule ? canDealerReschedule(request) : { canReschedule: false };

    const handleRescheduleClick = () => {
      // Initialize modal with current dates
      setRescheduleAvailableDate(moment(request.availableDate).toDate());
      setRescheduleDueDate(moment(request.dueDate).toDate());
      setShowDealerRescheduleModal(true);
    };

    const handleRescheduleConfirm = () => {
      onDealerReschedule(request, rescheduleAvailableDate, rescheduleDueDate);
      setShowDealerRescheduleModal(false);
    };

    return (
      <React.Fragment>
        <div className="card text-center">
          <div className="card-body">
            <ScheduleNotification request={request} calendarDays={calendarDays} />
            <ServiceTable
              data={services_}
              columns={getServiceStatusColumns()}
            />

            {/* Reschedule Button */}
            {rescheduleCheck.canReschedule && (
              <div className="text-center mt-3">
                <ActionButton
                  onClick={handleRescheduleClick}
                  className="btn btn-warning m-2 buttons"
                  userAccess={userAccess}
                >
                  RESCHEDULE JOB
                </ActionButton>
              </div>
            )}
          </div>
        </div>

        {/* Dealer Reschedule Modal */}
        <DealerRescheduleModal
          show={showDealerRescheduleModal}
          onHide={() => setShowDealerRescheduleModal(false)}
          request={request}
          onConfirm={handleRescheduleConfirm}
          availableDate={rescheduleAvailableDate}
          dueDate={rescheduleDueDate}
          onAvailableDateChange={setRescheduleAvailableDate}
          onDueDateChange={setRescheduleDueDate}
        />
      </React.Fragment>
    );
  }

// Multiple states for Dealer showing service status (STARTED and FINISHED - no reschedule allowed)
  const dealerStatusStates = [ REQUEST_STATES.STARTED, REQUEST_STATES.FINISHED];
  if (dealerStatusStates.includes(request.currentState) && userType === USER_TYPES.DEALER) {
    const services_ = prepareServiceStatusData(services);

    //console.log("RequestimateState : service  :", services)
    //console.log("RequestimateState : service history :", history)

    return (
      <React.Fragment>
        <div className="card text-center">
          <div className="card-body">
            <ScheduleNotification request={request} calendarDays={calendarDays} />
            <ServiceTable
              data={services_}
              columns={getServiceStatusColumns()}
            />
          </div>
        </div>
      </React.Fragment>
    );
  }
  
if (request.currentState === REQUEST_STATES.SCHEDULED && userType === USER_TYPES.DEALER) {
  const services_ = prepareServiceStatusData(services);
  const dealerRequiresContracts = props.company?.customer_contract === 'Y';

  // Check if dealer can reschedule
  const rescheduleCheck = canDealerReschedule ? canDealerReschedule(request) : { canReschedule: false };

  const handleRescheduleClick = () => {
    // Initialize modal with current dates
    setRescheduleAvailableDate(moment(request.availableDate).toDate());
    setRescheduleDueDate(moment(request.dueDate).toDate());
    setShowDealerRescheduleModal(true);
  };

  const handleRescheduleConfirm = () => {
    onDealerReschedule(request, rescheduleAvailableDate, rescheduleDueDate);
    setShowDealerRescheduleModal(false);
  };

  return (
    <React.Fragment>
      <div className="card text-center">
        <div className="card-body">
<ScheduleNotification request={request} calendarDays={calendarDays} />
          <ServiceTable
            data={services_}
            columns={getServiceStatusColumns()}
          />

          {/* Contract functionality - available until work starts */}
          {dealerRequiresContracts && (
            <div className="text-center mt-3">
              {!request.contract_url && (
                <div className="alert alert-warning mb-3">
                  <i className="fa fa-exclamation-triangle"></i>
                  <strong> Contract Required:</strong> Work cannot begin until customer contract is created and signed.
                </div>
              )}

              {request.contract_url && (
                <div className="alert alert-success mb-3">
                  <i className="fa fa-check-circle"></i>
                  <strong> Contract Ready:</strong> Customer contract is complete. Work can proceed.
                </div>
              )}

              {/* Contract Action Button */}
              {request.contract_url ? (
                <ActionButton
                  onClick={() => fetchSignedUrl(request.requestId)}
                  className="btn btn-info m-2 buttons"
                  userAccess={userAccess}
                >
                  VIEW CONTRACT
                </ActionButton>
              ) : (
                <ActionButton
                  onClick={() => window.location.href = `/contract/${request.requestId}`}
                  className="btn btn-primary m-2 buttons"
                  userAccess={userAccess}
                >
                  CREATE CONTRACT
                </ActionButton>
              )}
            </div>
          )}

          {/* Reschedule Button */}
          {rescheduleCheck.canReschedule && (
            <div className="text-center mt-3">
              <ActionButton
                onClick={handleRescheduleClick}
                className="btn btn-warning m-2 buttons"
                userAccess={userAccess}
              >
                RESCHEDULE JOB
              </ActionButton>
            </div>
          )}
        </div>
      </div>

      {/* Dealer Reschedule Modal */}
      <DealerRescheduleModal
        show={showDealerRescheduleModal}
        onHide={() => setShowDealerRescheduleModal(false)}
        request={request}
        onConfirm={handleRescheduleConfirm}
        availableDate={rescheduleAvailableDate}
        dueDate={rescheduleDueDate}
        onAvailableDateChange={setRescheduleAvailableDate}
        onDueDateChange={setRescheduleDueDate}
      />
    </React.Fragment>
  );
}

  // Finished job for Dealer - Review
  if (request.currentState === REQUEST_STATES.COLLECTED && userType === USER_TYPES.DEALER) {
    return (
      <React.Fragment>
        <div className="card text-center">
          <div className="card-body">
            <h5 className="card-title">Rate the installer work</h5>
            <div className="col-lg-12">
              <StarRatingComponent
                name="rate1"
                starCount={5}
                value={reviewScore}
                onStarClick={onReviewScoreChange}
              />
            </div>
            <ActionButton
              onClick={() => onReview(request)}
              className="btn btn-success m-2 buttons"
              disabled={!reviewScore}
              userAccess={userAccess}
            >
              REVIEW
            </ActionButton>
          </div>
        </div>
      </React.Fragment>
    );
  }

  //************************************************************************
  //***************************  Installer Pages ***************************
  //************************************************************************

  // New Request display for Installer Estimate
// UPDATED LOGIC - Replace existing conditions

// 1. DISCOVERY JOBS (assigned_to = 0) - Require CLAIM action
const isDiscoveryJob = request.currentState === REQUEST_STATES.NEW && 
  userType === USER_TYPES.INSTALLER && 
  request.requestType === REQUEST_TYPES.DEALER && 
  request.assignedTo === 0;

// 2. DIRECT ASSIGNMENTS (assigned_to = specialist_id) - Just need BOOK action  
const isDirectAssignment = request.currentState === REQUEST_STATES.NEW && 
  userType === USER_TYPES.INSTALLER && 
  request.requestType === REQUEST_TYPES.DEALER && 
  request.assignedTo === parseInt(typeId); // Directly assigned to this specialist

// 3. RETAIL JOBS (installer creates their own) - Just need BOOK action
const isRetailJob = request.currentState === REQUEST_STATES.NEW && 
  userType === USER_TYPES.INSTALLER && 
  request.requestType === REQUEST_TYPES.INSTALLER;

// COMBINED logic for jobs that just need booking (not claiming)
const isInstallerNewRequest = isRetailJob || isDirectAssignment;

if (isInstallerNewRequest) {
  const selectRow = {
    mode: "radio",
    clickToSelect: true,
    bgColor: "grey",
    onClick: (e, row, rowIndex) => {
      onSelectOffer(row);
    },
  };

  const rowEvents = {
    onClick: (e, row, rowIndex) => {
      onSelectOffer(row);
    },
  };

  const services_ = prepareServiceData(services);
  const showTransferOption = canTransferJob(request, { installer_id: parseInt(typeId) });

  return (
    <React.Fragment>
      <div className="card text-center">
        <div className="card-body">
          <ServiceTable 
            data={services_} 
            columns={getCustomServiceColumns()} 
          />
        </div>
<AvailabilityAlert 
  availability={availability} 
  calendarDays={calendarDays}
  requestId={request.requestId}
  selectedDate={sDate}
  jobType={request.requestType}  // Pass job type for context
/>
<DatePickerSection 
  sDate={sDate}
  minDate={minDate}                    // Today (can't book in past)
  maxDate={maxDate}                    // Due date constraint (dealer jobs only)
  exclude={[]}                         // No excluded dates - specialist decides
  existingCommitmentDates={existingCommitmentDates}  // Visual info only
  onStartDateChange={onStartDateChange}
  label="Pick Start Date"
/>
        <div className="row justify-content-center">
          <div className="col-12 text-center">
            <ActionButton
              onClick={() => onAcceptEstimate(request, startDate)}
              className="btn btn-success m-2 buttons"
              userAccess={userAccess}
            >
              BOOK JOB
            </ActionButton>

            {/* NEW: Transfer button */}
            {showTransferOption && company.installer_group && (
              <ActionButton
                onClick={onShowTransferModal}
                className="btn btn-outline-warning m-2 buttons"
                userAccess={userAccess}
              >
                TRANSFER
              </ActionButton>
            )}

            {/* Existing buttons */}
            {request.requestType === 'installer' && <ActionButton
              onClick={() => onShowDepositModal(request)}
              className="btn btn-outline-secondary m-2 buttons"
              userAccess={userAccess}
            >
              SET DEPOSIT AMOUNT 
            </ActionButton>}

            <ActionButton
              onClick={() => onEdit(request)}
              className="button btn-secondary m-2 buttons"
              userAccess={userAccess}
            >
              EDIT
            </ActionButton>
            <ActionButton
              onClick={() => onDelete(request)}
              className="btn btn-danger m-2 buttons"
              userAccess={userAccess}
            >
              DELETE
            </ActionButton>
            <ActionButton
              onClick={() => onCompleteEstimate(request, startDate)}
              className="btn btn-primary m-2 buttons"
              userAccess={userAccess}
            >
              JOB COMPLETED
            </ActionButton>

            {/* Existing deposit modal */}
            <DepositModal
              show={showDepositModal}
              onHide={onHideDepositModal}
              request={request}
              onSaveDeposit={onSaveDeposit}
            />
          </div>
        </div>
      </div>

      {/* NEW: Transfer Modal */}
      <TransferInterface
        request={request}
        currentInstaller={{ installer_id: parseInt(typeId) }}
        onTransfer={onJobTransfer}
        onCancel={onHideTransferModal}
        show={showTransferModal}
      />
    </React.Fragment>
  );
}

  // New request for Installer user for a dealer request (unassigned)

  if (isDiscoveryJob) {
    const services_ = prepareServiceData(services);

    return (
      <React.Fragment>
        <div className="card text-center">
          <div className="card-body">
            <ServiceTable 
              data={services_} 
              columns={getCustomServiceColumns()} 
            />
<AvailabilityAlert 
  availability={availability} 
  calendarDays={calendarDays}
  requestId={request.requestId}
  selectedDate={sDate}
  jobType={request.requestType}  // Pass job type for context
/>

<DatePickerSection 
  sDate={sDate}
  minDate={minDate}                    // Today (can't book in past)
  maxDate={maxDate}                    // Due date constraint (dealer jobs only)
  exclude={[]}                         // No excluded dates - specialist decides
  existingCommitmentDates={existingCommitmentDates}  // Visual info only
  onStartDateChange={onStartDateChange}
  label="Pick Start Date"
/>
            <div className="text-center">
              <ActionButton
                onClick={() => onAccept(request, sDate)}
                className="btn btn-success m-2 buttons"
                userAccess={userAccess}
              >
                CLAIM
              </ActionButton>
              <ActionButton
                onClick={() => onReject(request)}
                className="btn btn-danger m-2 buttons"
                userAccess={userAccess}
              >
                REJECT
              </ActionButton>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }

  // Installer receiving car from dealer/customer
  if (request.currentState === REQUEST_STATES.SCHEDULED && userType === USER_TYPES.INSTALLER) {
    return (
      <React.Fragment>
        <div className="card text-center">
                  {/* ADD DEPOSIT MESSAGE HERE - BEFORE VehicleInfo */}
  {request.depositAmount > 0 && request.requestType === 'installer' && (
  <div className={`alert ${request.depositIsPaid ? 'alert-success' : 'alert-warning'} mx-3 mb-3 mt-3`}>
    <strong>Deposit Required:</strong> ${request.depositAmount}
    <div>
      <span className={request.depositIsPaid ? 'text-success' : 'text-warning'}>
        {request.depositIsPaid ? ' ✅ PAID' : ' ⏳ NOT PAID'}
      </span>
      {request.depositPaidAmount > 0 && (
        <small className="d-block">${request.depositPaidAmount} received</small>
      )}
           </div>
          </div>
        )}

          <VehicleInfo 
            request={request}
            vin={vin}
            vinGood={vinGood}
            vehicleEntered={vehicleEntered}
            onVINChange={onVINChange}
          />
          <div className="text-center">
            <ActionButton
              onClick={() => onReceive(request, vin)}
              className="button btn-success m-2 buttons"
              disabled={!vinGood}
              userAccess={userAccess}
            >
              CHECK IN
            </ActionButton>
            <ActionButton
              onClick={() => handleCheckIn(request, routerHistory)}
              className="button btn-success m-2 buttons"
              userAccess={userAccess}
            >
              NEW CHECK IN
            </ActionButton>

            <ActionButton
              onClick={() => onReject(request)}
              className="button btn-danger m-2 buttons"
              userAccess={userAccess}
            >
              REJECT
            </ActionButton>
            <ActionButton
              onClick={() => onReschedule(request)}
              className="button btn-success m-2 buttons"
              userAccess={userAccess}
            >
              RESCHEDULE
            </ActionButton>
            <ActionButton
              onClick={() => onEdit(request)}
              className="button btn-secondary m-2 buttons"
              userAccess={userAccess}
            >
              EDIT
            </ActionButton>
          </div>
        </div>
      </React.Fragment>
    );
  }

  // Service work states for Installer
  const installerWorkStates = [REQUEST_STATES.RECEIVED, REQUEST_STATES.STARTED];
  if (installerWorkStates.includes(request.currentState) && userType === USER_TYPES.INSTALLER) {
    const selectRow = {
      mode: "radio",
      clickToSelect: true,
      style: { bgColor: "grey" },
      onSelect: (e, row, rowIndex) => {
        onSelectService(rowIndex);
      },
    };

    const services_ = prepareServiceData(services);

    //console.log("What do I have before converting :", services);
    //console.log("Services :", services_);
    //console.log("This Job : ", thisJob);
    //console.log("Selected Service : ", selectedService);

    //console.log("🔧 RequestimateState: About to return JSX");

    return (
      <React.Fragment>
        <div className="card text-center">
          <div className="card-body">
            <div className="row text-center">
              <div className="col text-center">
                <h5 className="card-title">VIN : {request.vin}</h5>
              </div>
            </div>
            <div className="mt-4 mb-4">
              <ServiceTable 
                data={services_} 
                columns={getWorkServiceColumns()}
                selectRow={selectRow}
              />
              <form>
                <div className="form-row justify-content-center">
                  <div className="form-group col-lg-12 text-center">
                    <ActionButton
                      onClick={() => onStart(request, thisJob, thisJob[selectedService].serviceId)}
                      className="btn btn-success m-2 buttons"
                      disabled={!rowSelected || (rowSelected && services_[selectedService].service_state !== SERVICE_STATES.NEW)}
                      userAccess={userAccess}
                    >
                      START SERVICE
                    </ActionButton>
                    <ActionButton
                      onClick={() => onFinish(request, thisJob, thisJob[selectedService].serviceId)}
                      className="btn btn-primary m-2 buttons"
                      disabled={!rowSelected || (rowSelected && services_[selectedService].service_state !== SERVICE_STATES.STARTED)}
                      userAccess={userAccess}
                    >
                      FINISH SERVICE
                    </ActionButton>
                    <ActionButton
                      onClick={() => onComplete(request, thisJob)}
                      className="btn btn-primary m-2 buttons"
                      userAccess={userAccess}
                    >
                      COMPLETE JOB
                    </ActionButton>
                    {request.requestType === REQUEST_TYPES.INSTALLER && (
                      <ActionButton
                        onClick={() => onDelete(request)}
                        className="button btn-danger m-2 buttons"
                        userAccess={userAccess}
                      >
                        DELETE JOB
                      </ActionButton>
                    )}
                    {noteText !== "None" && (
                      <button
                        type="button"
                        onClick={() => alert(noteText)}
                        className="button btn-info m-2 buttons"
                      >
                        NOTES
                      </button>
                    )}
                    <ActionButton
                      onClick={() => onEdit(request)}
                      className="button btn-secondary m-2 buttons"
                      userAccess={userAccess}
                    >
                      EDIT
                    </ActionButton>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }

  // Customer/Dealer picks up car from Installer
  if (request.currentState === REQUEST_STATES.FINISHED && userType === USER_TYPES.INSTALLER) {
    let PO = "Not Yet";
    if ((Object.keys(workingInvoice?.metadata || {})).length > 3 && workingInvoice?.metadata?.PO > "") {
      PO = Object.values(workingInvoice.metadata.PO);
    }

    return (
      <React.Fragment>
        <div className="row">
          <div className="col text-center">
            {invoice.paid ? (
              <h6>Customer has fully paid</h6>
            ) : (
              <h6>The customer invoice has been created</h6>
            )}
          </div>
        </div>
        <div className="row">
          <div className="col text-center">
            VIN : {request.vin.substring(0,2) === "NV" ? (<b>Not Collected</b>) : (request.vin)}
          </div>
        </div>
        <div className="row">
          <div className="col text-center">
            Invoiced : ${invoice.amount_due/100}
          </div>
        </div>
        {request.requestType === REQUEST_TYPES.DEALER && !invoice.paid && (
          <div className="row">
            <div className="col text-center">
              PO Received : {PO}
            </div>
          </div>
        )}
        <div className="row">
          <div className="col text-center">
            Remaining : ${!invoice.paid ? invoice.amount_remaining/100 : 0}
          </div>
        </div>

        {/* Upload completion photos - available for all installers */}
        {userType === USER_TYPES.INSTALLER && (
          <div className="row">
            <div className="col text-center">
              <ActionButton
                onClick={() => setShowCompletionPhotos(true)}
                className="button btn-primary m-2 buttons"
                userAccess={userAccess}
              >
                {isMobile ? 'TAKE COMPLETION PHOTOS' : 'UPLOAD COMPLETION PHOTOS'}
              </ActionButton>
            </div>
          </div>
        )}

        {((invoice.paid && request.requestType === REQUEST_TYPES.INSTALLER)) && (
          <div className="row">
            <div className="col text-center">
              <ActionButton
                onClick={() => onDeliver(request)}
                className="button btn-success m-2 buttons"
                userAccess={userAccess}
              >
                DELIVER
              </ActionButton>
              <ActionButton
                onClick={() => onResend(invoice.id)}
                className="button btn-success m-2 buttons"
                userAccess={userAccess}
              >
                SEND INVOICE
              </ActionButton>
            </div>
          </div>
        )}
        
        {(request.requestType === REQUEST_TYPES.DEALER) && (
          <div>
            {/* Payment options for dealer jobs with open invoices */}
            {invoice.status === "open" && (
              <div>
                <div className="row text-center">
                  <div className="col-4"/>
                  <div className="col-4 text-center">
                    <Select
                      name="paymethod"
                      label=" "
                      options={payList}
                      value={selectedPay}
                      onChange={onPaymentChange}
                    />
                  </div>
                </div>

                {/* Check number input - only show when Check is selected */}
                {selectedPay === "Check" && (
                  <div className="row text-center mt-3">
                    <div className="col-4"/>
                    <div className="col-4">
                      <div className="form-group">
                        <label htmlFor="checkNumber" className="font-weight-bold">
                          Check Number <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          id="checkNumber"
                          name="checkNumber"
                          className="form-control"
                          value={checkNumber}
                          onChange={onCheckNumberChange}
                          placeholder="Enter check number"
                          required
                          autoFocus
                        />
                        <small className="form-text text-muted">
                          Required for check payments
                        </small>
                      </div>
                    </div>
                  </div>
                )}

                <div className="row">
                  <div className="col text-center">
                    <ActionButton
                      onClick={() => {
                        if (selectedPay === "Split Payment") {
                          setShowSplitPaymentModal(true);
                        } else {
                          onPayment();
                        }
                      }}
                      className="button btn-success m-2 buttons"
                      userAccess={userAccess}
                    >
                      PROCESS PAYMENT
                    </ActionButton>
                    <ActionButton
                      onClick={() => onResend(invoice.id)}
                      className="button btn-success m-2 buttons"
                      userAccess={userAccess}
                    >
                      SEND INVOICE
                    </ActionButton>
                  </div>
                </div>
              </div>
            )}

            {/* Always show DELIVER, ADD PO, and DELETE buttons */}
            <div className="row">
              <div className="col text-center">
                <ActionButton
                  onClick={() => onDeliver(request)}
                  className="button btn-success m-2 buttons"
                  userAccess={userAccess}
                >
                  DELIVER
                </ActionButton>
                {invoice.status !== "open" && (
                  <ActionButton
                    onClick={() => onResend(invoice.id)}
                    className="button btn-success m-2 buttons"
                    userAccess={userAccess}
                  >
                    SEND INVOICE
                  </ActionButton>
                )}
                {PO === "Not Yet" && (
                  <ActionButton
                    onClick={() => onAddPO()}
                    className="button btn-success m-2 buttons"
                    userAccess={userAccess}
                  >
                    ADD PO
                  </ActionButton>
                )}
                {/* Only show delete button if invoice is not paid */}
                {!invoice.paid && (
                  <ActionButton
                    onClick={() => onDelete(request)}
                    className="button btn-danger m-2 buttons"
                    userAccess={userAccess}
                  >
                    DELETE FULL JOB
                  </ActionButton>
                )}
              </div>
            </div>
          </div>
        )}
        
        {(invoice.status === "open" && request.requestType === REQUEST_TYPES.INSTALLER) && (
          <div>
            <div className="row text-center">
              <div className="col-4"/>
              <div className="col-4 text-center">
                <Select
                  name="paymethod"
                  label=" "
                  options={payList}
                  value={selectedPay}
                  onChange={onPaymentChange}
                />
              </div>
            </div>

            {/* Check number input - only show when Check is selected */}
            {selectedPay === "Check" && (
              <div className="row text-center mt-3">
                <div className="col-4"/>
                <div className="col-4">
                  <div className="form-group">
                    <label htmlFor="checkNumber" className="font-weight-bold">
                      Check Number <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      id="checkNumber"
                      name="checkNumber"
                      className="form-control"
                      value={checkNumber}
                      onChange={onCheckNumberChange}
                      placeholder="Enter check number"
                      required
                      autoFocus
                    />
                    <small className="form-text text-muted">
                      Required for check payments
                    </small>
                  </div>
                </div>
              </div>
            )}

            <div className="row">
              <div className="col text-center">
                <ActionButton
                  onClick={() => {
                    if (selectedPay === "Split Payment") {
                      setShowSplitPaymentModal(true);
                    } else {
                      onPayment();
                    }
                  }}
                  className="button btn-success m-2 buttons"
                  userAccess={userAccess}
                >
                  PROCESS PAYMENT
                </ActionButton>
                <ActionButton
                  onClick={() => onResend(invoice.id)}
                  className="button btn-success m-2 buttons"
                  userAccess={userAccess}
                >
                  SEND INVOICE
                </ActionButton>
                {/* Only show delete button if invoice is not paid */}
                {!invoice.paid && (
                  <ActionButton
                    onClick={() => onDelete(request)}
                    className="button btn-danger m-2 buttons"
                    userAccess={userAccess}
                  >
                    DELETE FULL JOB
                  </ActionButton>
                )}
              </div>
            </div>
          </div>
        )}

        {/* Split Payment Modal */}
        <SplitPaymentModal
          show={showSplitPaymentModal}
          onHide={() => setShowSplitPaymentModal(false)}
          request={request}
          invoice={invoice}
          collectedPayments={collectedPayments}
          remainingBalance={remainingBalance}
          splitPaymentAmount={splitPaymentAmount}
          selectedSplitMethod={selectedSplitMethod}
          splitCheckNumber={splitCheckNumber}
          isProcessingSplitPayment={isProcessingSplitPayment}
          splitPaymentError={splitPaymentError}
          onSplitMethodChange={onSplitMethodChange}
          onSplitAmountChange={onSplitAmountChange}
          onSplitCheckNumberChange={onSplitCheckNumberChange}
          onCollectSplitPayment={onCollectSplitPayment}
          userAccess={userAccess}
        />

        {/* Online Invoice Link Modal */}
        {showInvoiceLinkModal && (
          <Modal show={showInvoiceLinkModal} onHide={onCloseInvoiceLinkModal} centered>
            <Modal.Header closeButton>
              <Modal.Title>Online Payment Invoice Created</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p>The invoice has been created and sent to the customer's email.</p>
              <p>You can also share this payment link:</p>
              <div className="input-group">
                <input
                  type="text"
                  className="form-control"
                  value={currentInvoiceLink}
                  readOnly
                />
                <div className="input-group-append">
                  <button
                    className="btn btn-outline-secondary"
                    onClick={() => {
                      navigator.clipboard.writeText(currentInvoiceLink);
                      alert('Link copied to clipboard!');
                    }}
                  >
                    Copy
                  </button>
                </div>
              </div>
              <p className="mt-3 text-muted">
                <small>Close this modal to refresh and see the payment status.</small>
              </p>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="primary" onClick={onCloseInvoiceLinkModal}>
                Close & Refresh
              </Button>
            </Modal.Footer>
          </Modal>
        )}

        {(invoice.status === "draft" && request.requestType === REQUEST_TYPES.INSTALLER) && (
          <div>
            <div className="row">
              <div className="col text-center">
                <ActionButton
                  onClick={() => onFinalize(invoice.id)}
                  className="button btn-success m-2 buttons"
                  userAccess={userAccess}
                >
                  SEND INVOICE
                </ActionButton>
                {/* Delete button is available for draft invoices - they can be deleted */}
                <ActionButton
                  onClick={() => onDelete(request)}
                  className="button btn-danger m-2 buttons"
                  userAccess={userAccess}
                >
                  DELETE FULL JOB
                </ActionButton>
              </div>
            </div>
          </div>
        )}
        
      {selectedPay === "SWIPE CARD" && showSwipe && (
        <PaymentProgressModal
          show={showSwipe}
          onClose={closeSwipe}
          paymentState={paymentState}
          paymentError={paymentError}
          invoice={invoice}
          installer={installer}
          onRetry={onRetryPayment}
        />
      )}

        {showPO && (
          <AddPO
            show={showPO}
            onClose={closePO}
            type={"dealer"}
            requestId={request.requestId}
            invoiceId={invoice.id}
            poNumber={PO}
            onPO={onPO}
            onInvoice={onSettle}
          />
        )}

        {showCompletionPhotos && (
          <CompletionPhotosModal
            show={showCompletionPhotos}
            onHide={() => setShowCompletionPhotos(false)}
            requestId={request.requestId}
            onSuccess={handleCompletionPhotosSuccess}
          />
        )}
      </React.Fragment>
    );
  }

  return null;
};

export default RequestimateState;